import commonTabsLayout from '@assets/css/common-tabs-layout.css';

/**
 * Common tabs layout styles.
 * @type {CSSStyleSheet}
 */
export const commonTabsLayoutStyles = new CSSStyleSheet();
commonTabsLayoutStyles.replaceSync(commonTabsLayout);
